// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2_-3O","inner":"Form_inner__plQPj","range":"Form_range__3pTAh","name":"Form_name__xjwLs","actions":"Form_actions__EguqC"};